<template>
    <div>
        <profile-info-edit v-if="isEdit" />
        <profile-info v-else />
        
        <contract-paper v-margin.top="2" />     

        <contract-status v-if="isIdentified" />

        <contract-electronic v-else v-margin.top="2" />
    </div>
</template>
<script>
import { ContractStatus } from '../contractStatus';
import { ContractPaper } from '../contractPaper';
import { ContractElectronic } from '../contractElectronic';
import ProfileInfo from './ProfileInfoContainer';
import ProfileInfoEdit from './ProfileInfoEditContainer';

export default {
    name: 'profile',
    props: {
        isIdentified: Boolean,
    },
    components: {
        ContractStatus,
        ContractPaper,
        ContractElectronic,
        ProfileInfo,
        ProfileInfoEdit,
    },
    computed: {
        isEdit() {
            return !!this.$route.params.edit;
        }
    },
}
</script>


// WEBPACK FOOTER //
// Profile.vue?0f88a025